
import { Directive, Injector, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ViewComponent } from '../pages/abstract/view.component';

@Directive({
  selector: '[formErrorMessages]'
})
export class FormErrorMessagesComponent extends ViewComponent implements OnInit {
  @Input('formErrorMessages') control!: AbstractControl | null;


  constructor(
    protected override injector: Injector,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>
  ) {
    super(injector);
  }

  ngOnInit(): void {
    if (!this.control) return;
    //this.control.markAsTouched();
    //this.control.updateValueAndValidity();

    this.control.valueChanges.subscribe(() => this.renderError());
    this.control.statusChanges.subscribe(() => this.renderError());

    this.renderError();
  }

  private renderError(): void {
    // console.log("FormErrorMessagesComponent", this.control);
    this.viewContainer.clear();

    if (this.control?.invalid) {
      let errorMessage = '';
      if (this.control.hasError('required')) {
        if (this.control.hasError('matDatepickerParse')) {
          errorMessage = 'カレンダーで選択してください';
        } else {
          errorMessage = '入力してください';
        }
      } else if (this.control.hasError('matDatepickerParse')) {
        errorMessage = "カレンダーで選択してください";
      } else if (this.control.hasError('min')) {
        errorMessage = "小さすぎます";
      } else if (this.control.hasError('max')) {
        errorMessage = "大きすぎます";
      } else if (this.control.hasError('maxlength')) {
        errorMessage = `${this.control.getError('maxlength')?.requiredLength} 文字以下で入力してください`;
      } else if (this.control.hasError('minlength')) {
        errorMessage = `${this.control.getError('maxlength')?.requiredLength} 文字以上で入力してください`;
      } else if (this.control.hasError('serverError')) {
        errorMessage = this.control.errors?.['serverError'];
      } else {
        // errors オブジェクトから最初の値を取得
        const firstError = this.control.errors ? Object.values(this.control.errors)[0] : '';
        //console.log("firstError", firstError)
        errorMessage = firstError || '';
      }
      if (errorMessage) {
        this.viewContainer.createEmbeddedView(this.templateRef, {
          $implicit: errorMessage
        });
      }
      // console.log(errorMessage, this.viewContainer, this.templateRef, this.control);
    }
  }
}
